import { motion } from "framer-motion";
import { Check, Minus } from "lucide-react";

const ROWS = [
  ["Pillar Elite", "$49/mo", false, false, "Basic"],
  ["Stan Store Pro", "$79/mo", false, false, "Basic"],
  ["Podia Shaker", "$89/mo", false, false, "None"],
  ["Kajabi Kickstarter", "$149/mo", false, false, "Extra fee"],
];

const Cell = ({ ok }) =>
  ok ? (
    <span className="mz-gold-fill inline-flex w-5 h-5 rounded-full items-center justify-center">
      <Check size={11} className="text-[#1a1206]" strokeWidth={3} />
    </span>
  ) : (
    <Minus size={14} className="text-neutral-300 inline" strokeWidth={2} />
  );

export const MzCompare = () => (
  <section className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl mb-12 sm:mb-16"
      >
        <p className="mz-eyebrow mb-3">Compare the market</p>
        <h2 className="mz-h text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter">
          Priced like the basics. <span className="mz-gold-text">Built like the big leagues.</span>
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.6, delay: 0.1 }}
        className="rounded-2xl bg-white border border-neutral-100 shadow-[0_8px_40px_rgba(10,10,10,0.05)] overflow-hidden"
      >
        <div className="overflow-x-auto">
          <table className="w-full min-w-[640px] text-left" data-testid="monetize-compare">
            <thead>
              <tr className="border-b border-neutral-100">
                {["Platform", "Price", "Product drafts", "Integrated marketing", "Templates"].map((h) => (
                  <th key={h} className="px-5 sm:px-7 py-4 text-[10.5px] font-semibold tracking-[0.14em] uppercase text-neutral-400" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map(([name, price, drafts, integrated, templates]) => (
                <tr key={name} className="border-b border-neutral-50">
                  <td className="px-5 sm:px-7 py-4 text-sm font-medium text-neutral-500">{name}</td>
                  <td className="px-5 sm:px-7 py-4 text-sm text-neutral-500">{price}</td>
                  <td className="px-5 sm:px-7 py-4"><Cell ok={drafts} /></td>
                  <td className="px-5 sm:px-7 py-4"><Cell ok={integrated} /></td>
                  <td className="px-5 sm:px-7 py-4 text-sm text-neutral-400">{templates}</td>
                </tr>
              ))}
              <tr data-testid="goldkey-column" style={{ background: "linear-gradient(110deg, rgba(212,175,55,0.07), rgba(252,246,186,0.12), rgba(212,175,55,0.07))" }}>
                <td className="px-5 sm:px-7 py-5">
                  <span className="mz-h text-sm font-bold mz-gold-text">GoldKey Monetization Hub</span>
                  <span className="ml-2 text-[9px] font-bold uppercase tracking-widest text-[#1a1206] mz-gold-fill rounded-full px-2 py-0.5">This</span>
                </td>
                <td className="px-5 sm:px-7 py-5 text-sm font-bold text-neutral-900">$49/mo</td>
                <td className="px-5 sm:px-7 py-5"><Cell ok /></td>
                <td className="px-5 sm:px-7 py-5"><Cell ok /></td>
                <td className="px-5 sm:px-7 py-5 text-sm font-semibold text-neutral-800">3 industries</td>
              </tr>
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>
  </section>
);
